import axiosInstance from "../../utils/axios";


export const getVideos = async (tags, search, author, page) => {

    let queryString = '';
    if (tags.length > 0) {
        queryString += tags.map(tag => `tags_like=${tag}`).join('&');
    }
    if (search) {
        queryString += `&q=${search}`;
    }
    if (author) {
        queryString += `&author=${author}`;
    }
    if (page) {
        queryString += `&_limit=4&_page=${page}`;
    }
    const response = await axiosInstance.get(`/videos?${queryString}`);

    return { total: response.headers['x-total-count'], data: response.data };
}